import { keyframes } from '@emotion/react';

// Keyframe animations
export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const slideInRight = keyframes`
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const slideInLeft = keyframes`
  from {
    transform: translateX(20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const slideInUp = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

export const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

export const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

// Animation durations
export const DURATION = {
  fast: '0.2s',
  normal: '0.3s',
  slow: '0.5s',
};

// Animation easings
export const EASING = {
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
};

// Animation delays
export const DELAY = {
  short: '0.1s',
  medium: '0.2s',
  long: '0.3s',
};

// Animation presets that can be applied to components
export const ANIMATION_PRESETS = {
  // For cards
  cardHover: {
    transition: `all ${DURATION.normal} ${EASING.easeOut}`,
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 8px 16px 0 rgba(0,0,0,0.1)',
    },
  },
  
  // For buttons
  buttonHover: {
    transition: `all ${DURATION.fast} ${EASING.easeInOut}`,
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  
  // For icons
  iconHover: {
    transition: `all ${DURATION.fast} ${EASING.easeInOut}`,
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  
  // For list items
  listItemHover: {
    transition: `all ${DURATION.fast} ${EASING.easeInOut}`,
    '&:hover': {
      transform: 'translateX(5px)',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  
  // For form elements
  formElementFocus: {
    transition: `all ${DURATION.fast} ${EASING.easeInOut}`,
    '&:focus': {
      transform: 'scale(1.01)',
      boxShadow: '0 0 0 2px rgba(63, 81, 181, 0.2)',
    },
  },
  
  // For chip elements
  chipHover: {
    transition: `all ${DURATION.fast} ${EASING.easeInOut}`,
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  
  // For fade in animations
  fadeIn: {
    animation: `${fadeIn} ${DURATION.normal} ${EASING.easeOut} forwards`,
  },
  
  // For slide in from right
  slideInRight: {
    animation: `${slideInRight} ${DURATION.normal} ${EASING.easeOut} forwards`,
  },
  
  // For slide in from left
  slideInLeft: {
    animation: `${slideInLeft} ${DURATION.normal} ${EASING.easeOut} forwards`,
  },
  
  // For slide in from bottom
  slideInUp: {
    animation: `${slideInUp} ${DURATION.normal} ${EASING.easeOut} forwards`,
  },
  
  // For pulse animation
  pulse: {
    animation: `${pulse} 2s ${EASING.easeInOut} infinite`,
  },
  
  // For bounce animation
  bounce: {
    animation: `${bounce} 2s ${EASING.easeInOut} infinite`,
  },
  
  // For shimmer effect (loading state)
  shimmer: {
    backgroundImage: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%)',
    backgroundSize: '200% 100%',
    animation: `${shimmer} 1.5s ${EASING.easeInOut} infinite`,
  },
}; 